import * as React from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'up' | 'down' | 'warn' | 'brand' | 'purple';

const toneCls: Record<Tone, string> = {
  neutral: 'bg-bg-3 text-ink-1 border-line',
  up: 'bg-up/15 text-up-dim border-up/30',
  down: 'bg-down/15 text-down-dim border-down/30',
  warn: 'bg-warn/15 text-warn-dim border-warn/30',
  brand: 'bg-brand/15 text-brand-dim border-brand/30',
  purple: 'bg-purple/15 text-purple-dim border-purple/30',
};

export function Pill({
  tone = 'neutral',
  className,
  children,
  ...rest
}: { tone?: Tone } & React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium',
        toneCls[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
